// extracted by mini-css-extract-plugin
export default {"name":"BlockImageLink_name__TXKkb","image":"BlockImageLink_image__3U5oV","componentWrapper":"BlockImageLink_componentWrapper__UiVAp","fullHeight":"BlockImageLink_fullHeight__WVItK"};